<template>
  <div class="order">
    <div class="detailsa" style="position: relative">
      <div class="info">
        <img
          v-if="foms.name == '中国电信'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/电信.jpg"
        />
        <img
          v-if="foms.name == '中国联通'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/联通.jpg"
        />
        <img
          v-if="foms.name == '中国移动'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/移动.jpg"
        />
        <img
          v-if="foms.name == '三网通'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/三网通.jpg"
        />
        <img v-if="foms.name == '中国广电'" class="img" src="../assets/g.png" />
        <span class="card" style="width: 100%">
          <div class="name">
            {{ foms.virtualNumber ? foms.virtualNumber : foms.meCardNum }}
          </div>
          <div class="name" @click="pos" style="width: 80%">
            {{ foms.displayName }}
          </div>
        </span>
      </div>
      <!-- <div
        @click="switchs"
        style="
          position: absolute;
          color: #009fff;
          border-bottom-left-radius: 13px;
          border-top-left-radius: 13px;
          top: 30%;
          text-align: center;
          line-height: 26px;
          right: 0px;
          font-size: 16px;
          font-weight: 500;
          width: 80px;
          height: 26px;
          background: white;
          margin-left: 0px;
        "
      >
        切换账号
      </div> -->
      <div class="info" style="margin-top: 20px">
        <div class="detail-list">
          <div class="name">{{ foms.balance }}</div>
          <div class="name">设备余额</div>
        </div>
        <div class="detail-list">
          <div class="names">
            {{
              foms.sumFlowStr
                ? foms.sumFlowStr
                : Math.floor((foms.sumFlow / 1024) * 100) / 100 + "G"
            }}
          </div>
          <div class="names">总流量</div>
        </div>
        <div class="detail-list">
          <div class="names">
            {{ Math.floor((foms.consumeFlow / 1024) * 100) / 100 }}G
          </div>
          <div class="names" style="margin-top: 11px">已用流量</div>
        </div>
        <div class="detail-list">
          <div class="names">
            {{
              foms.sumFlowStr
                ? foms.sumFlowStr
                : Math.floor((foms.surplusFlow / 1024) * 100) / 100 + "G"
            }}
          </div>
          <div class="names">剩余流量</div>
        </div>
      </div>
    </div>
    <van-empty v-if="fom.length == 0" description="暂无订单" />
    <div class="detail" v-for="item in fom" :key="item.id">
      <div
        style="
          font-size: 18px;
          font-weight: 700;
          padding: 15px;
          display: flex;
          justify-content: space-between;
        "
      >
        <span
          style="
            text-align: start;
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          {{ item.mealName }}
        </span>
        <span style="color: #009fff" v-if="item.timeType == 1">生效中</span>
        <span style="color: green" v-if="item.timeType == 2">待生效</span>
        <span style="color: red" v-if="item.timeType == 3">已失效</span>
        <span style="color: red" v-if="item.timeType == 4">已退款</span>
      </div>
      <div
        style="
          font-size: 15px;
          padding: 0 15px;
          display: flex;
          justify-content: space-between;
        "
      >
        <span
          style="
            text-align: start;
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          {{ item.mealType }}
        </span>
        <span>
          {{
            item.sumFlowStr
              ? item.sumFlowStr
              : item.imaginaryQuantity
              ? Math.floor((item.imaginaryQuantity / 1024) * 100) / 100 + "G"
              : 0 + "G"
          }}
        </span>
      </div>
      <div
        style="
          font-size: 13px;
          padding: 15px;
          display: flex;
          justify-content: space-between;
        "
      >
        <span
          style="
            text-align: start;
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          开始：{{ item.addTime }}
        </span>
        <span
          style="
            text-align: right;
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          结束：{{ item.endTime }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { phoneSimCard } from "../api/cardOperation";
  import { Loading } from "element-ui";
  import Detail from "@/components/Detail.vue";
  import { getPayTypeAll } from "@/api/newPay";
  import { phoneOrders } from "@/api/cardOperation";
  export default {
    data() {
      return {
        activeNames: ["1"],
        fom: [],
        //支付类型列表
        payTypeList: [],
        foms: {},
      };
    },
    created() {},
    async mounted() {
      await this.getPayTypeAll();
      await this.phoneOrders();
      await this.phoneSimCard();
      await Loading.service();
    },
    methods: {
      switchs() {
        this.$router.push(`/switch`);
      },
      pos() {
        this.$toast({
          message: this.fom.displayName,
          position: "top",
        });
      },
      phoneSimCard() {
        phoneSimCard().then((res) => {
          if (res.status) {
            this.foms = res.data;
          }
        });
      },
      isDateBetween(startDate, endDate) {
        const currentDate = new Date();
        const startTimestamp = new Date(startDate).getTime();
        const endTimestamp = new Date(endDate).getTime();
        const currentTimestamp = currentDate.getTime();
        if (
          currentTimestamp >= startTimestamp &&
          currentTimestamp <= endTimestamp
        ) {
          return 1; //套餐生效中
        } else if (currentTimestamp < startTimestamp) {
          return 2; //套餐未生效
        } else if (currentTimestamp > endTimestamp) {
          return 3; //套餐已失效
        }
      },
      //支付类型
      getPayTypeAll() {
        getPayTypeAll().then((res) => {
          this.payTypeList = res.data;
        });
      },

      phoneOrders() {
        phoneOrders().then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              this.payTypeList.forEach((items) => {
                if (item.payType == items.payType) {
                  item.payType = items.payName;
                }
              });
              if (item.state == 4) {
                item.timeType = 4;
              } else {
                item.timeType = this.isDateBetween(item.addTime, item.endTime);
                if (item.melaValidityType == 0) {
                  item.melaValidity = item.melaValidity + "天";
                } else if (item.melaValidityType == 1) {
                  item.melaValidity = item.melaValidity + "月";
                } else if (item.melaValidityType == 2) {
                  item.melaValidity = item.melaValidity + "年";
                }
                if (item.mealType == "0") {
                  item.mealType = "自然月套餐";
                } else if (item.mealType == "1") {
                  item.mealType = "月卡套餐";
                } else if (item.mealType == "2") {
                  item.mealType = "联通自然月套餐";
                } else if (item.mealType == "3") {
                  item.mealType = "联通月卡套餐";
                } else if (item.mealType == "4") {
                  item.mealType = "叠加包套餐";
                } else if (item.mealType == "5") {
                  item.mealType = "无限叠加套餐";
                } else if (item.mealType == "6") {
                  item.mealType = "基础套餐";
                }
              }
            });
            this.fom = res.data;
            Loading.service().close();
          }
        });
      },
    },
    components: {
      Detail,
    },
  };
</script>

<style lang="scss" scoped>
  .tds {
    width: 30%;
    border: 1px solid rgb(190, 190, 190);
    border-right: 0;
    padding: 10px 10px;
  }
  .td {
    width: 70%;
    border: 1px solid rgb(190, 190, 190);
    padding: 10px 10px;
  }
  .order {
    background-color: #f5f5f5;
    height: 100vh;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;
    .detailsa {
      width: 100%;
      border-radius: 10px;
      background: url("../assets/微信图片_20210524132009.png") no-repeat;
      background-size: 100% 100%;
      padding: 10px;
      box-sizing: border-box;
      .info {
        height: 70px;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        .card {
          margin-left: 20px;
          width: 100%;
          height: 100%;
          // background: green;
          text-align: center;
          .name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            height: 30px;
            line-height: 30px;
            font-size: 15px;
            text-align: left;
            font-weight: 700;
            color: white;
          }
        }

        .detail-list {
          width: 30%;
          height: 70px;
          margin-left: 3%;
          .names {
            margin-top: 7px;
            font-size: 14px;
            color: white;
          }
          .name {
            margin-top: 8px;
            font-size: 14px;
            color: white;
          }
        }
        .detail-lists {
          width: 30%;
          height: 70px;
          margin-left: 3%;
          .names {
            margin-top: 7px;
            font-size: 14px;
            color: white;
          }
        }
      }
    }
    .detail {
      width: 100%;
      margin: 15px 0;
      border-radius: 10px;
      box-sizing: border-box;
      background-color: #ffff;
    }
  }
</style>
